import { Opportunity } from '../types';

const normalizeSearchValue = (value: unknown): string => {
  if (typeof value === 'string') {
    return value.toLowerCase().replace(/\s+/g, ' ').trim();
  }
  if (typeof value === 'number') {
    return String(value);
  }
  return '';
};

const searchableFields = (opportunity: Opportunity): unknown[] => [
  opportunity.title,
  opportunity.description,
  opportunity.instructions,
  opportunity.department,
  opportunity.industry,
  opportunity.procuring_organization,
  opportunity.procuring_type,
  opportunity.procuring_location,
  opportunity.city,
  opportunity.state,
  opportunity.source_type,
  opportunity.source_category,
  opportunity.unspsc_code,
  opportunity.unspsc_description,
  opportunity.buyer,
  opportunity.bid_number,
  opportunity.alternate_id,
  opportunity.contract_id,
];

export const opportunityMatchesSearch = (opportunity: Opportunity, searchTerm: string): boolean => {
  const terms = normalizeSearchValue(searchTerm).split(' ').filter(Boolean);
  if (!terms.length) return true;

  const haystack = searchableFields(opportunity)
    .map(normalizeSearchValue)
    .filter(Boolean)
    .join(' ');

  return terms.every((term) => haystack.includes(term));
};
